export default {
  hotelRequest: false,
  vegan: false,
  vegetarian: false,
  handicapped: false,
  allergies: []
};
